
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.87 18H4.144c-1.12 0-2.242-1.075-2.554-2.445L.083 8.937c-.345-1.514.426-2.824 1.663-2.824h.268V2.715c0-1.5.953-2.715 2.13-2.715h4.263c.486 0 1.02.394 1.26.93l.54 1.202c.05.112.23.245.33.245h5.33C17.044 2.377 18 3.594 18 5.093v10.192c0 1.381-.809 2.522-1.856 2.693a1.662 1.662 0 01-.274.022zM3.08 6.113h10.393c1.119 0 2.241 1.075 2.553 2.446l.908 3.986V5.093c0-.748-.478-1.357-1.067-1.357h-5.33c-.482 0-1.016-.395-1.256-.93l-.539-1.202c-.05-.112-.231-.245-.335-.245H4.144c-.588 0-1.064.607-1.064 1.356v3.398zm1.934 6.028c0-.426.346-.771.772-.771h1.873V9.643a.771.771 0 111.543 0v1.726h1.726a.771.771 0 110 1.543H9.202v1.874a.771.771 0 11-1.543 0v-1.874H5.786a.771.771 0 01-.772-.771z"}})])
          )
        }
      }
    